let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hffl9")).then(() => parcelRequire('eBOuu'));